import { useEffect } from "react";

type TitleSegment = string | number | null | undefined | false;

const PORTAL_TITLE_SUFFIX = "Euka Student Portal";

const normaliseGradeCode = (gradeCode?: number | null) => {
  if (gradeCode === null || gradeCode === undefined) return undefined;
  return gradeCode % 10 === 0 ? gradeCode / 10 : gradeCode;
};

export const buildLessonCode = (
  gradeCode?: number | null,
  termId?: string | number | null,
  weekId?: string | number | null,
  lessonId?: string | number | null
) => {
  const normalisedGradeCode = normaliseGradeCode(gradeCode);
  if (
    normalisedGradeCode === undefined ||
    termId === null ||
    termId === undefined ||
    weekId === null ||
    weekId === undefined ||
    lessonId === null ||
    lessonId === undefined
  ) {
    return undefined;
  }

  return `G${normalisedGradeCode}T${termId}W${weekId}L${lessonId}`;
};

export const buildPageTitle = (...segments: TitleSegment[]) => {
  const cleanedSegments = segments
    .map(segment => {
      if (segment === null || segment === undefined || segment === false)
        return "";
      return String(segment).trim();
    })
    .filter(Boolean);

  if (!cleanedSegments.length) return PORTAL_TITLE_SUFFIX;

  return `${cleanedSegments.join(" | ")} | ${PORTAL_TITLE_SUFFIX}`;
};

export const usePageTitle = (...segments: TitleSegment[]) => {
  const title = buildPageTitle(...segments);

  useEffect(() => {
    document.title = title;
  }, [title]);
};
